<template>
    <div class="popup">
        <div class="button"
          @click="show = !show" />
        <div class="mask"
          @click.self="show = !show"
          v-if="show">
            <img class="view" src="../img/popup/popup.png" />
        </div>
    </div>
</template>
<script>
export default {
  data () {
    return {
      show: false
    }
  }
}
</script>
<style lang="less" scoped>
.popup {
  .button {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 2;
    width: 60px;
    height: 60px;
    background: url('../img/popup/button.png');
    background-size: 100% 100%;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);

    .view {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 4;
      width: 375px;
      height: 400px;
      margin: auto;
      animation: go_out 0.2s;
    }
  }
}

@keyframes go_out {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
